import React from 'react';

import { agencyStrings } from '@data/agency';
import { AgencyBase } from '@models/Agency';
import { makeMuiStyles } from '@styles/index';
import Color from 'color';

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    ...common.middleText,
    display: 'grid',
    gridTemplateColumns: 'minmax(100px, 1fr) 4fr minmax(100px, 1fr) 4fr',
    '& > div': {
      ...common.textAlignCenter,
      ...common.textGray700,
      padding: '0.5rem',
    },
    '& > div:nth-child(2n-2)': {
      borderBottom: `1px solid ${Color(theme.palette.primary.main).alpha(0.1).toString()}`,
    },
    '& > div:nth-child(-2n+2)': {
      borderTop: `1px solid ${Color(theme.palette.primary.main).alpha(0.1).toString()}`,
    },
    '& > div:nth-child(4n-2)': {
      borderRight: `1px solid ${Color(theme.palette.primary.main).alpha(0.1).toString()}`,
    },
    '& > $rightmost': {
      borderRight: `1px solid ${Color(theme.palette.primary.main).alpha(0.1).toString()}`,
    },
    '& > div[role="key"]': {
      ...common.fontWeight700,
      ...common.textBlack,
      backgroundColor: Color(theme.palette.primary.main).alpha(0.1).toString(),
    },
  },
  rightmost: {},
}));

interface AgencyInfoProps {
  agency?: AgencyBase;
}

export const AgencyInfo: React.FC<AgencyInfoProps> = (props) => {
  const { agency } = props;
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div role="key">{agencyStrings.englishName}</div>
      <div className={classes.rightmost} style={{ gridColumn: 'span 3' }}>
        {agency?.name_en || '-'}
      </div>
      <div role="key">{agencyStrings.englishNameShort}</div>
      <div>{agency?.name_en_short || '-'}</div>
      <div role="key">{agencyStrings.fcpNo}</div>
      <div>{agency?.fcp_no || '-'}</div>
      <div role="key">{agencyStrings.japaneseName}</div>
      <div>{agency?.name || '-'}</div>
      <div role="key">{agencyStrings.japaneseNameShort}</div>
      <div>{agency?.name_short || '-'}</div>
      <div role="key">{agencyStrings.address1}</div>
      <div>{agency?.address1 || '-'}</div>
      <div role="key">{agencyStrings.address2}</div>
      <div>{agency?.address2 || '-'}</div>
      <div role="key">{agencyStrings.phone}</div>
      <div>{agency?.phone || '-'}</div>
      <div role="key">{agencyStrings.fax}</div>
      <div>{agency?.fax || '-'}</div>
    </div>
  );
};
